module.exports = __webpack_public_path__ + "assets/alert-triangle-d06e91.svg";